__turbopack_context__.v({
  "content": "AdvisorSection-module__hdzZnW__content",
  "entryAnimation": "AdvisorSection-module__hdzZnW__entryAnimation",
  "image": "AdvisorSection-module__hdzZnW__image",
  "root": "AdvisorSection-module__hdzZnW__root",
  "section-1": "AdvisorSection-module__hdzZnW__section-1",
  "section-2": "AdvisorSection-module__hdzZnW__section-2",
  "social-btns": "AdvisorSection-module__hdzZnW__social-btns",
  "text": "AdvisorSection-module__hdzZnW__text",
});
